<template>
  <div class="main-container page__forgetPassword">
    <header class="headerBlue">
        <a @click="historyBack()" class="btnBack">
            <span class="btnBack__svg">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="arrow_back_24px">
                <path id="icon/navigation/arrow_back_24px" d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#3CB5A8"/>
                </g>
                </svg>
            </span>
        </a>
        <div class="containerTitle">
            <h1 v-if="statusWallet">{{translationArray.reactivate_wallet}}</h1>
            <h1 v-else>{{translationArray.activate_wallet}}</h1>
            <p v-if="!statusWallet"><span class="containerTitle__subtitle">{{translationArray.on_my_object}}</span><span class="bold">{{referenceProduct}}</span></p>
        </div>

        <div class="containerPartner">
            <img src="../../static/img/senzu.png" alt="">
        </div>
        <div class="containerDescription">
            <p class="information__title__computer">{{translationArray.activate_wallet}}</p>
            <p>{{translationArray.login_wallet}}</p>
        </div>
    </header>
    <section class="body">
        <form id="login" @submit="checkLogin" method="POST">
            <fieldset class="formRow">
                <legend>{{translationArray.email}}</legend>
                <input type="email" id="email" name="email" v-model="email">
            </fieldset>
            <fieldset class="formRow">
                <legend>{{translationArray.password}}</legend>
                <input type="password" id="password" name="password" v-model="password">
            </fieldset>
            <div class="formRow">
                <input class="submit" type="submit" value="Se connecter">
            </div>
            <input type="hidden" name="senzu_token" :value="csrfToken">
            <a @click="redirectPassword()" class='link forgetPassword' v-if="isDesktop">{{translationArray.forget_password}}</a>
        </form>     
    </section>
    <footer>
        <p>{{translationArray.more_on}}<a href="#" class="link_confidentiality">{{translationArray.privacy_rules}}</a></p>
    </footer>
  </div>
</template>

<script>
import {translate} from '../../static/js/translate';

export default {
  name: 'Wallet',
  data () {
    return {
      referenceProduct: null,
      idRecord: null,
      keyRecord: null,
      translationArray: {},
      statusWallet: false,
      fromAuthorize: (localStorage.getItem("last_page") === "Authorize"),
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  mounted() {
    this.translationArray = translate(navigator.language.substr(0, 2));

    let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
    if(clientId <= 8 || typeof(clientId) == 'undefined') {
        this.isSenzuApp = true;
    }

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.referenceProduct = localStorage.getItem("reference");
    if(localStorage.getItem("wallet_status") == 0) {
      //Reactivate
      this.statusWallet = true;
    } else {
      //Create
      this.statusWallet = false;
    }

    

    let idUser = this.$route.query.id_user;
    this.idRecord = this.$route.query.id_record;
    this.keyRecord = this.$route.query.key;

    if(this.isNtag424 == "false") {
        document.getElementsByClassName("askPin")[0].remove();
    }
  },
  watch: {
    checkboxPin: function(value) {
      if(value) {
        this.modalDisplay = true;
        this.modalWarning = true;
      } else {
        this.savedMe = false;
      }
    },
    wrongPinModal: function(value) {
      let _this = this;
      var interval = setInterval(function() {
          _this.wrongPinModal = false;
          clearInterval(interval);
      }, 5800);
    },
  },
  methods: {
    checkLogin: function(e) {
        e.preventDefault();

        const dataBody = {email: this.email, password: this.password};
        localStorage.setItem("data_authorize", JSON.stringify(dataBody));

        let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
        let responseType = typeof(this.$route.query.response_type) !== "undefined" ? this.$route.query.response_type : null;
        let redirectUri = typeof(this.$route.query.redirect_uri) !== "undefined" ? this.$route.query.redirect_uri : null;
        let scope = typeof(this.$route.query.scope) !== "undefined" ? this.$route.query.scope : null;
        let codeChallenge = typeof(this.$route.query.code_challenge) !== "undefined" ? this.$route.query.code_challenge : null;
        let codeChallengeMethod = typeof(this.$route.query.code_challenge_method) !== "undefined" ? this.$route.query.code_challenge_method : null;
        let state = typeof(this.$route.query.state) !== "undefined" ? this.$route.query.state : null;

        let params = "?client_id="+ clientId + "&response_type=" + responseType + "&redirect_uri=" + redirectUri + "&scope="
          + scope + "&code_challenge=" + codeChallenge + "&code_challenge_method=" + codeChallengeMethod + "&state=" + state;

        if(responseType === null && redirectUri === null && codeChallenge === null && codeChallengeMethod === null && state === null) {
          fetch(`${this.$origin}/data?client_id=${this.$route.query.client_id}&key=${this.$route.query.key}`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
                  'CSRF-Token': this.csrfToken
              },
          }).then(result => result.json())
          .then(data => {
            clientId = data.client_id;
            responseType = data.response_type;
            redirectUri = data.redirect_uri;
            scope = data.scope;
            codeChallenge = data.code_challenge;
            codeChallengeMethod = data.code_challenge_method;
            state = data.state;

            params = "?client_id="+ clientId + "&response_type=" + responseType + "&redirect_uri=" + redirectUri + "&scope="
              + scope + "&code_challenge=" + codeChallenge + "&code_challenge_method=" + codeChallengeMethod + "&state=" + state;

            this.fetchAuthorize(dataBody, params);
          });
        } else {
          this.fetchAuthorize(dataBody, params);
        }       
    },
    fetchAuthorize: function(data, params) {
      fetch(`${this.$origin}/authorize${params}`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'CSRF-Token': this.csrfToken
          },
          body: JSON.stringify(data)
      }).then(result => result.json())
      .then(data => {
        //TODO ask roles
        localStorage.setItem("user", JSON.stringify(data.user));

        if(data.redirect_uri != null || data.redirect_roles != null) {
          params = "?id_record=" + this.$route.query.id_record + "&id_user=" + data.user.id;

          fetch(`${this.$origin}/update-wallet${params}`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
                  'CSRF-Token': this.csrfToken
              }
          }).then(result => result.json())
          .then(data => {
            if(data.error === 200) {
              //call to /update-wallet to create PIN and Wallet
              this.$router.replace({name: "CreatePin", query: {
                  id_record: this.$route.query.id_record,
                  key: this.$route.query.key,
                  client_id: this.$route.query.client_id,
                  redirect_uri: this.$route.query.redirect_uri,
                  response_type: this.$route.query.response_type,
                  scope: this.$route.query.scope,
                  code_challenge: this.$route.query.code_challenge,
                  code_challenge_method: this.$route.query.code_challenge_method,
                  state: this.$route.query.state,
                }
              });
            }
          });
        }

        if(data.error === 400) {
          this.wrongAuth = true;
        } else {
          this.wrongAuth = false;
        }
      });
    },
    redirectPassword: function() {
       this.$router.replace({name: 'ResetPassword'});
    },
    handleResize: function() {
      if(window.innerWidth <= 1120) {
          this.isMobile = true;
          this.isDesktop = false;
      } else {
          this.isMobile = false;
          this.isDesktop = true;
      }
    },
    historyBack: function() {
      let query = {};
      let lastPage = null;
      if(localStorage.getItem("last_page") === "ChooseUsers" || localStorage.getItem("last_page") === "QrCode") {
        lastPage = localStorage.getItem("last_page");
        this.$senzuAuth.lastPage = "Authorize";
        localStorage.setItem("last_page", "Authorize");
        query = {
          id_record: this.$route.query.id_record,
          key: this.$route.query.key,
          client_id: this.$route.query.client_id, 
          redirect_uri: this.$route.query.redirect_uri,
          response_type: this.$route.query.response_type,
          scope: this.$route.query.scope,
          code_challenge: this.$route.query.code_challenge,
          code_challenge_method: this.$route.query.code_challenge_method,
          state: this.$route.query.state,
        }
      } else {
        lastPage = "Authorize";
        query = {
          client_id: this.$route.query.client_id, 
          redirect_uri: this.$route.query.redirect_uri,
          response_type: this.$route.query.response_type,
          scope: this.$route.query.scope,
          code_challenge: this.$route.query.code_challenge,
          code_challenge_method: this.$route.query.code_challenge_method,
          state: this.$route.query.state,
        }
      }

      this.$router.replace({name: lastPage, query});
    },
    updateModal: function(value) {
      if(this.modalWarning) {
        this.modalWarning = false;
        this.modalDisplay = false;
      } else {
        this.modalDisplay = true;
        this.modalWarning = true;        
      }
      if(value) {
          this.savedMe = true;
      } else {
          this.checkboxPin = false;
      }
    },
    addDigit: function(number) {
      let boxes = $(".passwordBox--empty");
      boxes.first().addClass('passwordBox--enter');
      boxes.first().removeClass('passwordBox--empty');

      if(this.digitPin.length < 6) {
        this.digitFinal += number;
        this.digitPin += "*";
      }
    },
    removeDigit: function() {
      let boxes = $(".passwordBox--enter");
      boxes.last().addClass('passwordBox--empty');
      boxes.last().removeClass('passwordBox--enter');

      if(this.digitPin.length > 0) {
        this.digitPin = this.digitPin.substring(0, this.digitPin.length - 1);
        this.digitFinal = this.digitFinal.substring(0, this.digitFinal.length - 1);
      }
    },
    checkPin: function() {
      let params = "id_record=" + this.$route.query.id_record + "&key=" + this.$route.query.key + "&id_user=" + this.$route.query.id_user + 
      "&client_id=" + this.$route.query.client_id + "&redirect_uri=" + this.$route.query.redirect_uri +
      "&response_type=" + this.$route.query.response_type + "&scope=" + this.$route.query.scope + 
      "&code_challenge=" + this.$route.query.code_challenge + "&code_challenge_method=" + this.$route.query.code_challenge_method +
      "&state=" + this.$route.query.state;

      if(this.digitFinal.length === 6) {
        fetch(`${this.$origin}/check-pin?${params}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'CSRF-Token': this.csrfToken
            },
            body: JSON.stringify({pin: this.digitFinal, savedMe: this.savedMe})
        }).then(result => result.json())
        .then(data => {
          if(typeof(data.redirect_uri) != 'undefined') {
            this.modalDisplay = true;
            this.loadingConnection = true;
            //window.history.pushState({}, '', "https://oauth.senzu.app");
            const intervalAbort = setInterval(function() {
                clearInterval(intervalAbort);
                this.$router.replace({name: "Authorize", query: {
                        client_id: this.$route.query.client_id,
                        redirect_uri: this.$route.query.redirect_uri,
                        response_type: this.$route.query.response_type,
                        scope: this.$route.query.scope,
                        code_challenge: this.$route.query.code_challenge,
                        code_challenge_method: this.$route.query.code_challenge_method,
                        state: this.$route.query.state,
                    }
                });
            }, 5000);
            window.location.replace(data.redirect_uri);
          } else {
            this.wrongPinModal = true;
            this.amountTry = data.amount_try;
            this.statusWallet = data.status;
          }
        });
      }
    },
    abortRedirect: function() {
      this.$router.replace({name: "Authorize", query: {
          client_id: this.$route.query.client_id, 
          redirect_uri: this.$route.query.redirect_uri,
          response_type: this.$route.query.response_type,
          scope: this.$route.query.scope,
          code_challenge: this.$route.query.code_challenge,
          code_challenge_method: this.$route.query.code_challenge_method,
          state: this.$route.query.state,
        }
      });
      clearInterval(intervalAbort);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Wallet.vue